var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Z",
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4v4",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6h4",
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 11,
    x2: 14.568,
    y2: 7.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8201BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#1619A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#00C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 6,
    y1: 8,
    x2: 7.463,
    y2: 7.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8201BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#1619A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#00C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 4,
    y1: 7,
    x2: 6.516,
    y2: 4.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8201BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#1619A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#00C5FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/add-circle-icon.884f398c3ecec2ae3380c65c92b9f583c1bf01655c20d261f5ca0106254320f6.svg";
export { ForwardRef as ReactComponent };